
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Home, ArrowLeft } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { getFontClass } from "@/constants/languages";

const NotFoundPage = () => {
 const navigate = useNavigate();
 const { t, isRTL, language } = useLanguage();
 const fontClass = getFontClass(language);

 return (
 <div className={`min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-green-100 p-4 ${fontClass}`} dir={isRTL ? 'rtl' : 'ltr'}>
 <Card className="w-full max-w-md glass-card border-white/20 text-center">
 <CardContent className="p-8">
 <div className="text-6xl font-bold text-blue-600 mb-4">404</div>
 <h1 className="text-2xl font-semibold mb-2">{t("notFound.title")}</h1>
 <p className="text-muted-foreground mb-6">
 {t("notFound.description")}
 </p>
 
 <div className="flex flex-col sm:flex-row gap-3 justify-center">
 <Button onClick={() => navigate(-1)} variant="outline">
 <ArrowLeft className="h-4 w-4 me-2 rtl-flip" />
 {t("notFound.goBack")}
 </Button>
 <Link to="/">
 <Button>
 <Home className="h-4 w-4 me-2" />
 {t("notFound.home")}
 </Button>
 </Link>
 </div>
 </CardContent>
 </Card>
 </div>
 );
};

export default NotFoundPage;
